import { CCDPTracking } from "Types/api/Tracking";
import { getOrCreateId } from "@carsdotcom/ccdp-sdk/lib/es6/domains/id";

export async function getCCDPTrackingObject(): Promise<CCDPTracking> {
    return {
        visitor_ids: [await getOrCreateId()],
    };
}
